import { Typography } from "@mui/material"
import moment from "moment"
import { ILastUpdatedDate } from "./LastUpdatedDate.interfaces"
import { StyledBox } from "./LastUpdatedDate.styled"
import { useTranslation } from "react-i18next"

const LastUpdatedDate = (props: ILastUpdatedDate) => {
  const { date } = props
  const { t } = useTranslation()

  return (
    <div>
      <StyledBox mt={{ xs: 2, lg: 0 }}>
        <Typography variant="bodySmall" color="textSecondary">
          {t("vehicleregistry.transport_data_retrieved", "Transport Board data retrieved")}: {moment(date).format("YYYY-MM-DD")}
        </Typography>
      </StyledBox>
    </div>
  )
}
export default LastUpdatedDate
